import { ComponentPropsWithoutRef, FC, ReactNode, useState } from 'react';
import { DescriptionContainer, HoverDescription } from 'jbc-front/components/presenters/ui/HoverDescription';
import styles from './Description.scss';

interface DescriptionProps extends ComponentPropsWithoutRef<'div'> {
  text: ReactNode;
  children: ReactNode;
}

export const Description: FC<DescriptionProps> = ({ text, children, ...rest }) => {
  const [isHover, setIsHover] = useState(false);

  return (
    <DescriptionContainer {...rest} onMouseEnter={() => setIsHover(true)} onMouseLeave={() => setIsHover(false)}>
      {children}
      <HoverDescription isHover={isHover} position="top" margin="32px">
        <span className={styles.bold}>{text}</span>
      </HoverDescription>
    </DescriptionContainer>
  );
};
